const statusOf = (error: unknown): number | undefined => {
  if (typeof error !== "object" || error === null || !("status" in error)) {
    return undefined
  }

  if (
    error.status === "PARSING_ERROR" &&
    "originalStatus" in error &&
    typeof error.originalStatus === "number"
  ) {
    return error.originalStatus
  }

  return typeof error.status === "number" ? error.status : undefined
}

/**
 * Whether a failed refresh means the stored token is dead, as opposed to the server not answering.
 *
 * Only an outright rejection should end a session. A dropped connection or a 5xx says nothing
 * about the token — the request has already been retried by then — and throwing it away over one
 * costs a login that was never needed.
 */
export const isRefreshTokenRejected = (error: unknown): boolean => {
  const status = statusOf(error)

  return status === 400 || status === 401
}
